import Backbone from 'backbone';

export const BackboneEvents = function () {};
Object.setPrototypeOf(BackboneEvents.prototype, Backbone.Events);
